module.exports = __webpack_public_path__ + "static/media/dark_country_p2e.14df2624.webp";